import config from "../../config";
const baseUrl = config.baseUrl;

export const BookingsUrls = {

  BOOKINGS_ADD: baseUrl + "/booking",
  BOOKINGS_EDIT: baseUrl + "/booking",
  BOOKINGS_LIST: baseUrl + "/booking",
  BOOKINGS_DELETE: baseUrl + "/booking",
  BOOKINGS_GETBYID: baseUrl + "/booking",
  BOOKING_DROPDOWN: baseUrl + "/booking/dropdown",
  BOOKING_ROLLBACK: baseUrl + "/booking/rollback",
  BOOKINGS_DELETE_HARD: baseUrl + "/booking",
}; 